
<div class="theme-layout " [class.naps-layout-wrapper]="!isUserLoggedIn()" id="scrollup">
  <app-header #headerElement></app-header>
  <section [class.naps-main-section]="!isUserLoggedIn()">
    <div>
      <router-outlet></router-outlet>
    </div>
  </section>
  @if(!isUserLoggedIn()){
    <app-footer></app-footer>
  }
</div>